import axios from 'axios'
import Common from '../js/Common' // 引入axios
import qs from 'qs'

// import axios from 'axios'
//
// // 实例对象
// const instance = axios.create({
//   timeout: 3000,
//   headers: {
//     'Content-Type': 'application/x-www-form-urlencoded'
//   }
// })
//
// instance.defaults.baseURL = 'http://192.168.1.1:8086/portal/'
//
// // 请求拦截器
// instance.interceptors.request.use(
//   config => {
//     config.data = qs.stringify(config.data) // 转为formdata数据格式
//     return config
//   },
//   error => Promise.error(error)
// )
//
// export default instance

// 环境的切换
if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = Common.apiUrl
} else if (process.env.NODE_ENV === 'debug') {
  axios.defaults.baseURL = Common.apiUrl
} else if (process.env.NODE_ENV === 'production') {
  axios.defaults.baseURL = Common.apiUrl
}
axios.defaults.timeout = 30000
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8;multipart/form-data'
axios.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8;multipart/form-data'
// axios.defaults.headers('Content-Security-Policy:upgrade-insecure-requests')
// 请求拦截器
axios.interceptors.request.use(
  config => {
    // config.headers['Content-Security-Policy'] = 'upgrade-insecure-requests'

    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
    // const token = store.state.token
    // token && (config.headers.Authorization = token)
    let token = window.localStorage.getItem(Common.userToken)
    if (token) {
      // 将token放到请求头发送给服务器,将tokenkey放在请求头中
      config.headers.accessToken = token
      // 也可以这种写法
      // config.headers['accessToken'] = Token;
    }
    config.data = qs.stringify(config.data, {arrayFormat: 'repeat'}) // 转为formdata数据格式
    return config
  },
  error => {
    return Promise.error(error)
  })

// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      if (response.data.code === '87') {
        // 后台管理权限不足(跳转至网站首页并登录)
      }
      return Promise.resolve(response)
    } else {
      return Promise.reject(response)
    }
  },
  // 服务器状态码不是200的情况
  error => {
    console.log(error.response.status)

    // if (error.response.status) {
    //   switch (error.response.status) {
    //     // 401: 未登录
    //     // 未登录则跳转登录页面，并携带当前页面的路径
    //     // 在登录成功后返回当前页面，这一步需要在登录页操作。
    //     case 401:
    //       router.replace({
    //         path: '/login',
    //         query: { redirect: router.currentRoute.fullPath }
    //       })
    //       break
    //     // 403 token过期
    //     // 登录过期对用户进行提示
    //     // 清除本地token和清空vuex中token对象
    //     // 跳转登录页面
    //     case 403:
    //       Toast({
    //         message: '登录过期，请重新登录',
    //         duration: 1000,
    //         forbidClick: true
    //       })
    //       // 清除token
    //       localStorage.removeItem('token')
    //       store.commit('loginSuccess', null)
    //       // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
    //       setTimeout(() => {
    //         router.replace({
    //           path: '/login',
    //           query: {
    //             redirect: router.currentRoute.fullPath
    //           }
    //         })
    //       }, 1000)
    //       break
    //     // 404请求不存在
    //     case 404:
    //       Toast({
    //         message: '网络请求不存在',
    //         duration: 1500,
    //         forbidClick: true
    //       })
    //       break
    //     // 其他错误，直接抛出错误提示
    //     default:
    //       Toast({
    //         message: error.response.data.message,
    //         duration: 1500,
    //         forbidClick: true
    //       })
    //   }
    //   return Promise.reject(error.response)
    // }
  }
)

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get (url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      console.log(url + '        ' + err)
      reject(err)
    })
  })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post (url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        console.log(url + '        ' + err)
        reject(err)
      })
  })
}
/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function put (url, params) {
  return new Promise((resolve, reject) => {
    axios.put(url, params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        console.log(url + '        ' + err)
        reject(err)
      })
  })
}
/**
 * del方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function del (url, params) {
  return new Promise((resolve, reject) => {
    axios.delete(url, {
      params: params
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      console.log(url + '        ' + err)
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/request/http.js